// extracted by mini-css-extract-plugin
export default {"loader":"style_loader__kz6Q5","loader_img":"style_loader_img__UKn-M","animation":"style_animation__HfexL"};